export class UpdateDoctorSubscription {
  plan: string;
  paymentReferenceNo: string;
  paymentDate: string;
  paidAmount: number;
  maxDoctors: number;
  statusChange: string;
}
